import React, { useState, useEffect, useContext } from "react";
import { LanguageContext } from "./LanguageContext";
import { languageOptions, dictionaryList } from "./index";
import { ConfigProvider } from 'antd';
import moment from 'moment';
import enUS from 'antd/es/locale/en_US';
import zhCN from 'antd/es/locale/zh_CN';
import zhTW from 'antd/es/locale/zh_TW'
import 'moment/locale/zh-cn';
import { getPersonalizedLanguageConfig } from "@/apis/apiCollection";
import tabIcon from "@/assets/images/favicon.svg"
import * as localforage from "localforage";
import { AuthContext } from "@/auths/Auth";
import { downloadFileLink } from "@/apis/announcementApi";
// it provides the language context to app
const antdLocalMap = {
  en: enUS,
  'zh-cn': zhCN,
  'zh_tw': zhTW
}

const personalizedLangCache = Object.fromEntries(Object.keys(languageOptions).map(lang => ([lang, {}])))
export const LanguageProvider = ({ children }) => {
  const {canLoadLangConf} = useContext(AuthContext)
  // 本地多语言
  const [userLanguage, setUserLanguage] = useState(
    localStorage.getItem("rcml-lang") || "en"
  );
  const [langConf, setLangConf] = useState({})

  // antd 多语言
  const [antdLocale, setAntdLocale] = useState(
    antdLocalMap[localStorage.getItem("rcml-lang")] ? antdLocalMap[localStorage.getItem("rcml-lang")] : zhCN
  );

  const changeAntdLanguage = (lang) => {
    moment.locale(lang)
    setAntdLocale(antdLocalMap[lang] ? antdLocalMap[lang] : zhCN);
  };

  const fetchData = () => {
    let lang = localStorage.getItem("rcml-lang");
    /**
     * To prevent error about someday someone to change lang name e.g. 'zh_tw' => 'tw', and user still have old rcml-lang value 'zh_tw' in browser indexDB,
     * so give it below conditional expressions to see if now includes this value, if not give it to default value 'en'
     * By Dylan
     * */
    if (!Object.keys(dictionaryList).includes(lang)) {
      localStorage.setItem("rcml-lang", "en");
      setUserLanguage("en");
      changeAntdLanguage("en")
    } else {
      setUserLanguage(lang || "en");
      changeAntdLanguage(lang)
    }
  };

  const provider = {
    userLanguage,
    langConf,
    dictionary: dictionaryList[userLanguage],
    userLanguageChange: (selected) => {
      const newLanguage = languageOptions[selected] ? selected : "en";
      setUserLanguage(newLanguage);
      changeAntdLanguage(newLanguage)
      localStorage.setItem("rcml-lang", newLanguage);
    },
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    window.__langDictionary = dictionaryList[userLanguage];

  }, [userLanguage]);


  useEffect(() => {
    if (!canLoadLangConf) return
    const personalizedLanguageConfig = personalizedLangCache[userLanguage]
    if (personalizedLanguageConfig.lang) {
      setLangConf(personalizedLanguageConfig)
    } else {
      localforage.getItem("userCompanyID").then(companyId => {
        getPersonalizedLanguageConfig({companyId, lang: userLanguage}).then(
          langConf => {
            const config = !langConf.lang?{}:{
              deviceCenter: JSON.parse(langConf.deviceCenter),
              deviceCenterTab: JSON.parse(langConf.deviceCenterTab),
              platform: JSON.parse(langConf.platform),
              platformTab: JSON.parse(langConf.platformTab),
              supportCenter: JSON.parse(langConf.supportCenter),
              nubisDrive: JSON.parse(langConf.nubisDrive)
            }
            personalizedLangCache[userLanguage] = config
            setLangConf(config)
          },
          () => {
            setLangConf({})
            personalizedLangCache[userLanguage] = {}
          }
        )
      })
    }
  }, [userLanguage, canLoadLangConf])

  useEffect(() => {
    if (langConf.platformTab?.icon) {
      downloadFileLink(langConf.platformTab.icon).then(res => setTabIcon(res.download_link))
    } else {
      setTabIcon(tabIcon)
    }
    if (langConf.platformTab?.text) {
      document.title = langConf.platformTab.text;
    } else {
      document.title = "Platform"
    }
  }, [langConf])

  // console.log('---antdLocale---',antdLocale)

  return (
    <LanguageContext.Provider value={provider}>
      <ConfigProvider locale={antdLocale}>
        {children}
      </ConfigProvider>
    </LanguageContext.Provider>
  );
};

function setTabIcon(iconUrl) {
  const link = document.querySelector("link[rel~='icon']");
    if (link) {
      link.href = iconUrl
    } else {
      const newLink = document.createElement('link')
      newLink.rel = 'icon';
      newLink.href = iconUrl
      document.head.appendChild(newLink);
    }
}